// sections: ["Acting", "Music", "Writing", "Code"]

// ALL SOCIAL LINKS
export const SocialLinks = [
    {
        name: "Actors Access",
        icon: "",
        class: "",
        link: "https://resumes.actorsaccess.com/caitlinklotz",
        sections: ["Acting"]
    },
    {
        name: "The Workbook",
        icon: "",
        class: "",
        link: "https://mycv.theworkbook.com/caitlin.klotz",
        sections: ["Acting"]
    },
    {
        name: "Casting Networks",
        icon: "",
        class: "",
        link: "https://app.castingnetworks.com/talent/public-profile/43df4c0c-077f-11ed-9999-c79179251fee",
        sections: ["Acting"]
    },
    {
        name: "Spotify",
        icon: "fa-brands fa-spotify",
        class: "icon",
        link: "https://open.spotify.com/artist/7K7E5F2950LM3k0TSOdubf",
        sections: ["Music"]
    },
    {
        name: "Apple Music",
        icon: "fa-brands fa-itunes-note",
        class: "icon",
        link: "https://music.apple.com/artist/1790138283",
        sections: ["Music"]
    },
    {
        name: "YouTube",
        icon: "fa-brands fa-youtube",
        class: "icon",
        link: "https://www.youtube.com/@caitlin.klotz.1",
        sections: ["Music"]
    },
    {
        name: "Amazon Music",
        icon: "fa-brands fa-amazon",
        class: "icon",
        link: "https://music.amazon.ca/tracks/B0DSW46YNM?marketplaceId=A2EUQ1WTGCTBG2&musicTerritory=CA&ref=dm_sh_gaURkbc2mUfJvyfkahkU5jk0i",
        sections: ["Music"]
    },
    {
        name: "Instagram",
        icon: "fa-brands fa-instagram",
        class: "icon",
        link: "https://www.instagram.com/caitlin.klotz.1",
        sections: ["Acting", "Music"]
    },
    {
        name: "Threads",
        icon: "fa-brands fa-threads",
        class: "icon",
        link: "https://www.threads.com/@caitlin.klotz.1",
        sections: ["Acting", "Music"]
    },
    {
        name: "Facebook",
        icon: "fa-brands fa-facebook",
        class: "icon",
        link: "https://www.facebook.com/caitlin.klotz.2",
        sections: ["Acting", "Music"]
    },
    {
        name: "X (Twitter)",
        icon: "fa-brands fa-x-twitter",
        class: "icon",
        link: "https://twitter.com/CaitlinKlotz",
        sections: ["Acting", "Music"]
    }
]